import type { ComponentProps } from "react";
import { Loader2 } from "lucide-react";

import { Badge } from "@/components/ui/badge";
import { cn } from "@/lib/utils";

type BadgeVariant = ComponentProps<typeof Badge>["variant"];

interface StatusBadgeProps {
  label: string;
  variant?: BadgeVariant;
  className?: string;
  showSpinner?: boolean;
}

export function StatusBadge({
  label,
  variant = "outline",
  className,
  showSpinner = false,
}: StatusBadgeProps) {
  return (
    <Badge variant={variant} className={className}>
      {showSpinner ? <Loader2 className={cn("size-3.5 animate-spin")} aria-hidden="true" /> : null}
      {label}
    </Badge>
  );
}
